<div class="modal-header">
  <h5 class="modal-title">{{ '::Feedback:Detail' | abpLocalization }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body position-relative">
  <div
    *ngIf="isLoading"
    class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75"
    style="z-index: 10">
    <div class="p-4">
      <i class="fas fa-spinner fa-spin fa-2x"></i>
    </div>
  </div>

  <div class="mb-4">
    <div class="d-flex align-items-center mb-2">
      <i class="fas fa-user me-2" style="width: 10px"></i>
      <span class="small me-2" style="width: 50px">{{ '::Feedback:From' | abpLocalization }}:</span>
      <span class="fw-semibold">{{ feedback?.creator?.name }} {{ feedback?.creator?.surname }}</span>
    </div>
    <div class="d-flex align-items-center mb-2">
      <i class="fas fa-building me-2" style="width: 10px"></i>
      <span class="small me-2" style="width: 50px">
        {{ '::Feedback:Source' | abpLocalization }}:
      </span>
      <span class="fw-semibold">{{ feedback?.source?.name }}</span>
    </div>
    <div class="d-flex align-items-center">
      <i class="fas fa-calendar me-2" style="width: 10px"></i>
      <span class="small me-2" style="width: 50px">{{ '::Feedback:Date' | abpLocalization }}:</span>
      <span class="fw-semibold">{{
          feedback?.creationTime
            ? (feedback.creationTime | caDatePipe: dateDisplayType.DateTimeWithoutSeconds : true)
            : ''
        }}</span>
    </div>
  </div>

  <div class="mb-2">
    <span class="small mb-3">
      <i style="width: 10px" class="fas fa-message me-2"></i>
      {{ '::Feedback:FeedbackMessage' | abpLocalization }}
    </span>
  </div>

  <div
    class="border rounded p-4 bg-light position-relative"
    style="height: 250px; overflow-y: auto">
    <span
      class="position-absolute opacity-25"
      style="top: 5px; font-size: 60px; left: 15px; line-height: 1; pointer-events: none">
      "
    </span>
    <div class="position-relative" style="z-index: 1; padding-left: 20px">
      {{ feedback?.feedback }}
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="closeModal()">
    <i class="fas fa-times me-1"></i>
    {{ '::Close' | abpLocalization }}
  </button>
</div>
